import { render, staticRenderFns } from "./DashboardPartner.vue?vue&type=template&id=293d4a0b&"
import script from "./DashboardPartner.vue?vue&type=script&lang=js&"
export * from "./DashboardPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports